import { Box } from '@mui/material';
import React from 'react';
import { DiscountCode } from './components/DiscountCode/DiscountCode';
import { NavBar } from '../../components/NavBar/NavBar';
import { ProductList } from './components/ProductList/ProductList';

export type IHomePageProps = {};

const HomePage: React.FC<IHomePageProps> = ({}) => {
  return (
    <Box sx={{
      position: 'relative', height: '100vh', overflow: 'hidden',
    }}
    >
      <NavBar />
      <ProductList />
      <DiscountCode />
    </Box>
  );
};

export { HomePage };
